export const GENRES = [
  "Films restaurés HD · Domaine public",
  "Fanfilms",
  "Séries originales Kinebe TV",
];

// Tags secondaires (classement par ambiance / genre narratif)
export const TAGS = [
  "Horreur",
  "Thriller",
  "Science-Fiction",
  "Action",
  "Comédie",
  "Drame",
  "Fantastique",
];

export const GENRE_DESCRIPTIONS = {
  "Fanfilms":
    "Tous les fanfilms en 4K avec des doublages dans les langues principales du cinéma : anglais, français, allemand, italien, irlandais, espagnol, et bien d'autres.",
  "Films restaurés HD · Domaine public":
    "Classiques du cinéma restaurés en haute définition et libres de droits — un patrimoine cinématographique revisité en qualité maximale.",
  "Séries originales Kinebe TV":
    "Séries exclusivement produites par Kinebe TV. Des univers originaux, racontés en plusieurs épisodes, en 4K Ultra HD Dolby Atmos.",
};

export const CONTENT_TYPES = [
  { value: "film", label: "Films" },
  { value: "serie", label: "Séries" },
];
